import React from "react";
import { formatNumberIN } from "./utils";

interface RechartsNumberTooltipProps {
  unit?: string;
  threshold?: number;
  showSeriesName?: boolean;
}

function formatCompactIN(value: number) {
  if (value === null || value === undefined || isNaN(value)) return "--";

  if (value < 100000) {
    // below 1 lakh → regular formatting
    return formatNumberIN(value);
  }

  // lakh
  if (value >= 100000 && value < 10000000) {
    return (value / 100000).toFixed(2).replace(/\.00$/, "") + "L";
  }

  // crore
  if (value >= 10000000) {
    return (value / 10000000).toFixed(2).replace(/\.00$/, "") + "Cr";
  }

  return formatNumberIN(value);
}

const RechartsNumberTooltip: React.FC<RechartsNumberTooltipProps & any> = ({
  unit = "",
  showSeriesName = false, // disabled by default
  active,
  payload,
  label,
}) => {
  if (!active || !payload || !payload.length) return null;

  return (
    <div
      style={{
        background: "white",
        border: "1px solid #e5e7eb",
        borderRadius: 8,
        padding: "8px 12px",
        minWidth: 120,
      }}
    >
      <div style={{ fontSize: 13, fontWeight: 600, marginBottom: 6 }}>
        {label}
      </div>

      {payload.map((p: any, i: number) => {
        const rawVal = p.value;
        const formatted = formatCompactIN(rawVal);

        return (
          <div
            key={i}
            style={{
              display: "flex",
              justifyContent: "space-between",
              gap: 8,
              alignItems: "center",
              marginBottom: 4,
            }}
          >
            <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
              <div
                style={{
                  width: 10,
                  height: 10,
                  borderRadius: 2,
                  background:
                    p.color || (p.payload && p.payload._color) || "#999",
                }}
              ></div>
            </div>

            <div style={{ textAlign: "right", fontSize: 13, color: "#111" }}>
              {formatted}
              {unit ? ` ${unit}` : ""}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default RechartsNumberTooltip;
